var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "prompt-heading" }, [
      _vm._v(_vm._s(_vm._f("trans")("Prompt Modifier"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "prompt-container" },
      _vm._l(
        this.creatorStudio.settings.prompt_modifier,
        function (option, index) {
          return _c(
            "div",
            { key: index },
            [_c("delete-prompt", { attrs: { prompt: option } })],
            1
          )
        }
      ),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }